import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { NotFound } from 'components/not-found';
import { Loader } from 'components/loader/loader';
import { Button } from 'components/ui/Button';
import { StatusEmployee } from 'components/status/status-employee';

import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import { ReactComponent as MoreIcon } from 'assets/images/more.svg';
import { ReactComponent as CheckIcon } from 'assets/images/check.svg';

import { ListAttr } from 'components/list';
import Breadcrumbs from 'components/breadcrumbs';
import { ActionMenu } from 'components/action-menu/action-menu';

import { BreadcrumbsProps } from 'constants/routers-breadcrumbs';
import { AttributesWhitelistEmployee } from 'constants/attributes';

import { employeeRoutes } from './routers-breadcrumbs';

import { getFilters, initialValues, validationSchema } from '../all/filter/config';
import { AsideFilter } from '../all/filter/filter';
import { mockData } from '../mock-data';

import s from './DetailEmployee.module.scss';
import { styled } from '@tanstack/react-query-devtools/build/lib/utils';

export const DetailEmployee = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const employee = mockData.employeeList.find((emp) => emp.id === id);

  const [isEditOpen, setIsEditOpen] = useState(false);

  // if (isFetching) {
  //   return <Loader size="ultra" />;
  // }

  const roleOptions = mockData.filterRoleList;

  const filtersForEdit = useMemo(
    () => getFilters(t, 'edit', { roleOptions, employee }),
    [t, roleOptions, employee],
  );

  const initialForEdit = useMemo(
    () => initialValues('edit', { employee, roleOptions }),
    [employee, roleOptions],
  );

  const validationForEdit = validationSchema(t, 'edit');

  if (!employee) {
    return <NotFound title="Document not found" notFoundTitle="" hasSearch={false} />;
  }

  const detailAttrs = [
    { name: 'inn', value: employee.inn },
    { name: 'snils', value: employee.snils },
    { name: 'birthDate', value: employee.birthDate },
    { name: 'email', value: employee.email },
  ].filter((attr) => attr.value);

  return (
    <>
      <div className={s['container']}>
        <Breadcrumbs items={employeeRoutes} />

        <div className={s['content']}>
          <div className={s['header']}>
            <StatusEmployee status={employee?.status} />

            <div className={s['header-button']}>
              <Button
                icon={<EditIcon />}
                onClick={() => setIsEditOpen(true)}
                className={cx(s['button'])}
                displayType="outlined-tetriary"
                type="quaternary"
              >
                {t('Edit')}
              </Button>

              <ActionMenu>
                <ActionMenu.Button>
                  <MoreIcon />
                </ActionMenu.Button>
                <ActionMenu.Overlay placement="bottom-end" closeOnItemClick>
                  <div className={s['wrapper-btn']}>
                    <button role="menuitem" onClick={() => console.log('Edit')}>
                      Заблокировать
                    </button>
                    <button role="menuitem" onClick={() => console.log('Delete')}>
                      Удалить
                    </button>
                    <button role="menuitem" onClick={() => console.log('Copy link')}>
                      Скопировать ссылку на приглашение
                    </button>
                  </div>
                </ActionMenu.Overlay>
              </ActionMenu>
            </div>
          </div>

          <div className={s['details-header']}>
            <div className={s['detail-row']}>
              <span className={s['employee-name']}>{employee.name}</span>

              <div className={s['employee-info']}>
                <span className={s['employee-id']}>ID:</span>
                <span className={s['employee-id']}>{employee.id}</span>
              </div>
            </div>

            <ListAttr whitelist={AttributesWhitelistEmployee} attrs={detailAttrs} />
          </div>

          <div className={s['line']} />

          <div className={s['employee-content-role']}>
            <div className={s['employee-role']}>
              <span className={s['role-title']}>{t('Роль')}</span>
              <span className={s['role-value']}>{employee?.role}</span>
            </div>
          </div>

          <div className={s['employee-content']}>
            <div className={s['employee-role']}>
              <span className={s['role-title']}>{t('Полномочия')}</span>

              <div className={s['container-permission']}>
                {employee?.permissions?.map((p, idx) => (
                  <div key={idx} className={s['permission-row']}>
                    <CheckIcon />
                    <span className={s['permission-value']}>{p?.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AsideFilter
        isOpen={isEditOpen}
        isDetails
        title={t('Edit')}
        filters={filtersForEdit}
        initialValuesOverride={initialForEdit}
        validationSchemaOverride={validationForEdit}
        onSubmitForm={() => {
          console.log('submit');
        }}
        onClose={() => setIsEditOpen(false)}
      />
    </>
  );
};
